import axios from 'axios'

import { version } from '../../package.json'

import { getReportSuiteType } from './environment'

export function setInDataLayer(content) {
  window.dataLayer = { ...(window.dataLayer || {}), ...(content || {}) }
  return window.dataLayer
}

export async function sendAppLaunchEvent(userId, project) {
  return postDataToAnalytics('CX App:Launch', userId, project)
}

export async function postDataToAnalytics(event, userId, project = {}) {
  const { id, title, template } = project
  const ecid = await getEcid()

  axios({
    method: 'post',
    url: 'https://adobeioruntime.net/api/v1/web/demo-system/actions/analytics-proxy',
    data: {
      project: 'CX App',
      reportSuite: 'demosystem' + getReportSuiteType(),
      marketingCloudVisitorID: ecid,
      runMode: 'Web',
      appVersion: version,
      action: event,
      events: 'event1,event10',
      eVar1: 'CX App',
      eVar2: version,
      eVar3: title,
      eVar4: template,
      eVar5: userId,
      eVar6: event,
      eVar7: id,
      namespace: 'demosystem',
      pageName: event,
      pageURL: document.location.href,
      referrer: document.referrer,
    },
  })
}

async function getEcid() {
  const { alloy, _satellite } = window

  if (alloy) {
    return (await alloy('getIdentity'))?.identity?.ECID
  } else if (_satellite && _satellite.getVisitorId) {
    return _satellite?.getVisitorId()?.getMarketingCloudVisitorID()
  } else {
    console.warn(`Couldn't get ECID from alloy nor _satellite object`)
  }
}
